import React from 'react';

import PeriodSelector from '../PeriodSelector';

import RoadmapCriticalPathControl from './RoadmapCriticalPathControl';
import RoadmapFilterControl from './RoadmapFilterControl';
import RoadmapPeriodSelect from './RoadmapPeriodSelect';

import SegmentedControl from 'CommonComponents/SegmentedControl';
import ToggleInput from 'CommonComponents/ToggleInput';

// Show toggles; each is independent of View by and survives a view change.
const SHOW_TOGGLES = [
    { key: 'keyOnly', label: 'Key milestones only' },
    { key: 'firstLevel', label: 'First-level categories only' },
    { key: 'hideEmpty', label: 'Hide empty periods' },
];

const RoadmapControls = ({ settings, periodYears, filterOptions, schedule, onChange }) => (
    <div className="tw-flex tw-flex-wrap tw-items-end tw-gap-x-7 tw-gap-y-4 tw-px-[18px] tw-py-4 tw-rounded-[10px] tw-bg-[#f5f7fa]">
        <div className="tw-flex tw-flex-col tw-flex-shrink">
            <span className="inbud-control-label">{$t('Style')}</span>
            <SegmentedControl
                variant="track"
                options={[
                    { value: 'calendar', label: $t('Calendar') },
                    { value: 'list', label: $t('List') },
                ]}
                value={settings.style}
                onChange={(style) => onChange({ style })}
            />
        </div>

        <PeriodSelector period={settings.view} onChange={(view) => onChange({ view })} />

        <div className="tw-flex tw-flex-col">
            <span className="inbud-control-label">{$t('Show')}</span>
            <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-6 tw-gap-y-1.5 tw-min-h-[31px]">
                {SHOW_TOGGLES.map((toggle) => (
                    <ToggleInput
                        key={toggle.key}
                        noBottomSpacing
                        role="switch"
                        aria-checked={settings[toggle.key]}
                        label={$t(toggle.label)}
                        name={`roadmap-${toggle.key}`}
                        checked={settings[toggle.key]}
                        onChange={(event) => onChange({ [toggle.key]: event.target.checked })}
                    />
                ))}
            </div>
        </div>

        <RoadmapCriticalPathControl mode={settings.criticalPath} target={settings.criticalTarget} schedule={schedule} onChange={onChange} />

        <div className="tw-flex tw-flex-col tw-min-w-[180px]">
            <label htmlFor="roadmap-period" className="inbud-control-label">
                {$t('Period')}
            </label>
            <RoadmapPeriodSelect value={settings.period} years={periodYears} onChange={(period) => onChange({ period })} />
        </div>

        <div className="tw-flex tw-flex-col">
            <span className="inbud-control-label">{$t('Filter')}</span>
            <RoadmapFilterControl
                options={filterOptions}
                excludedSources={settings.excludedSources}
                excludedCategories={settings.excludedCategories}
                onChange={onChange}
            />
        </div>
    </div>
);

export default RoadmapControls;
